import { createSlice } from '@reduxjs/toolkit';

const enrollmentsSlice = createSlice({
  name: 'enrollments',
  initialState: {
    data: [],
    loading: true,

  },
  reducers: {
    hydrateEnrollments: (state, action) => {
      state.data = action.payload;
      state.loading = false;
    },
    requestEnrollments: (state, action) => {
      state.loading = true;
    },
  },
});

export default enrollmentsSlice;
